import { useState, useEffect } from "react";
import ShimmerLoader from "../../components/ShimmerLoader";
import { useDispatch, useSelector } from "react-redux";
import {
  fetchbnplduereport
} from "../flight/flightSlice";
import { selectCurrentUser } from '../auth/authSlice'
import Moment from "moment";
import { format, parseISO } from "date-fns";
import { Funnel } from "lucide-react";
import CurFt from "../../components/CurFt";
import Pagination from "../../components/Pagination";
import { BOOKING_STATUS } from "../../utils/constants";

export default function BnplDuereport() {
  const dispatch = useDispatch()
  const { bnpldueStatus, bnpldue } = useSelector((state) => state.flights);
  const perPage = 25;
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);

  const [BOOKINGSTATUS, SetBOOKINGSTATUS] = useState(BOOKING_STATUS);
  const [BookingHistory, SetBookingHistory] = useState([]);
  const user = useSelector(selectCurrentUser)
  const [FilterData, setFilterData] = useState({
    "filterType": "Flight",
    "bookingID": "",
    "PNRNumber": "",
    "BookingStatus": 1,
    "supplierType": "All",
    "JourneyType": "All",
    "Type": "All",
    "FirstName": "",
    "FromDate": null,
    "ToDate": null,
    "TravelFromDate": null,
    "TravelToDate": null,
    "validate": true
  });
  const fetchBookingHistory = async () => {
    dispatch(fetchbnplduereport({ FilterData, perPage, currentPage }));
  };
  useEffect(() => {
    fetchBookingHistory();
  }, [FilterData, currentPage]);

  useEffect(() => {
    const data = bnpldue?.Booking;
    SetBookingHistory(data?.data || []);
    setTotalPages(data?.last_page);
  }, [bnpldueStatus, bnpldue, currentPage]);


  return (
    <div className="bg-gray-100 text-gray-800 relative min-h-screen">

      {/* Main Content */}
      <main className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 mt-4 space-y-6">

        <div className="bg-white shadow-md rounded-lg p-4 mt-4">
          {/* Header */}
          <div className="flex items-center justify-between">
            <h3 className="font-semibold">
              Flight BNPL Due Report
            </h3>
            <span className="font-semibold text-blue-500 flex items-center gap-1">
              <div className="relative inline-block text-left">
                <button
                  className="px-5 py-2 rounded bg-blue-500 hover:bg-blue-600 text-white font-medium shadow transition"
                >
                  <Funnel />
                </button>
              </div>
            </span>
          </div>
        </div>
        <div className="bg-white shadow-md rounded-lg overflow-hidden p-2">
          <div className="overflow-x-auto">
            <table className="min-w-full border  text-sm">
              <thead className="bg-gray-100 text-gray-700">
                <tr>
                  <th className="px-3 py-2 border text-left">No.</th>
                  <th className="px-3 py-2 border text-left" nowrap="true">Trx Date</th>
                  <th className="px-3 py-2 border text-left" nowrap="true">Travel Date/Time</th>
                  <th className="px-3 py-2 border text-left">Booking ID/PNR</th>
                  <th className="px-3 py-2 border text-left">Summary</th>

                  <th className="px-3 py-2 border text-left" nowrap="true">Sale Price	</th>
                  <th className="px-3 py-2 border text-left" nowrap="true">Processing Fee</th>
                  <th className="px-3 py-2 border text-left" nowrap="true">Paid Amount</th>
                  <th className="px-3 py-2 border text-left" nowrap="true">Balance</th>
                  <th className="px-3 py-2 border text-left" nowrap="true">Passenger Name</th>
                  <th className="px-3 py-2 border text-left" nowrap="true"> Status</th>
                  <th className="px-3 py-2 border text-right">Action</th>
                </tr>
              </thead>
              <tbody>
                {bnpldueStatus === 'loading' ? (
                  <>
                    <tr className="border-b">
                      <td className="px-3 py-2 border" colSpan={12}>
                        <ShimmerLoader />
                        <ShimmerLoader />
                        <ShimmerLoader />
                        <ShimmerLoader />
                        <ShimmerLoader />
                      </td>
                    </tr>
                  </>
                ) : (
                  <>
                    {BookingHistory.length > 0 ? (
                      BookingHistory.map((item, key) => (
                        <tr className="border-b" key={key}>
                          <td className="px-3 py-2 border">{key + 1}</td>
                          <td className="px-3 py-2 border" nowrap="true">{format(parseISO(item.created_at), 'dd MMM, yyyy')}<br />
                            {Moment(item.created_at).format('h:mm A')}
                          </td>
                          <td className="px-3 py-2 border" nowrap="true">{Moment(item.FromUTCTime).format('ddd Do MMM')}<br />
                            {Moment(item.FromUTCTime).format('h:mm A')}
                          </td>
                          <td className="px-3 py-2 border" nowrap="true">
                            <a target='_blank' style={{ color: 'blue', textDecoration: 'underline' }} href={`/flight/booking-confirmation/${item.BookingID}`}>{item.BookingID}</a>
                            <br />PNR - {[...new Set(item.PNRNumber.split(','))].join(', ')}
                          </td>
                          <td className="px-3 py-2 border" nowrap="true">
                            {item.SoCode + '-' + item.DeCode + ' ' + item.FlightNumber}<br />
                            {item.AirlineName}
                          </td>
                          <td className="px-3 py-2 border">
                            <CurFt currency={item.Currncy} price={item.PubFare} />
                          </td>
                          <td className="px-3 py-2 border">
                            <CurFt currency={item.Currncy} price={item.ProAmt + item.GSTOnPro} />
                          </td>
                          <td className="px-3 py-2 border">
                            <CurFt currency={item.Currncy} price={item.ProAmt + item.GSTOnPro + item.BookAmt} />
                          </td>
                          <td className="px-3 py-2 border" nowrap="true">
                            <CurFt currency={item.Currncy} price={item.PendingAmount} /><br />
                            <span className="text-red-600">Due Date: - {Moment(item.DLDate).format('ddd Do MMM')}</span>
                          </td>
                          <td className="px-3 py-2 border" nowrap="true">{item.customerName} <br />Total Pax:{item.totalPax}</td>
                          <td className="px-3 py-2 border" nowrap="true">
                            {(item.BookingStatus == 1) ? <span style={{ color: 'green' }}>{BOOKINGSTATUS[item.BookingStatus]}</span> : <span style={{ color: 'red' }}>{BOOKINGSTATUS[item.BookingStatus]}</span>}
                          </td>
                          <td className='text-right px-3 py-2 border'>
                            <a target='_blank' style={{ color: 'blue', textDecoration: 'underline' }} href={`/flight/booking-confirmation/${item.BookingID}`}>View</a>
                          </td>
                        </tr>
                      ))
                    ) : (
                      <>
                        <tr className="border-b">
                          <td colSpan={12} className="px-3 py-2 border">No record found</td>
                        </tr>
                      </>
                    )}
                  </>
                )}

              </tbody>
            </table>
            <Pagination totalPages={totalPages} currentPage={currentPage} setCurrentPage={setCurrentPage} />
          </div>
        </div>
      </main>

    </div>
  );
}
